package blazern.lexisoup.data.kaikki.model

import kotlinx.serialization.Serializable

@Serializable
data class FormOf(
    val word: String,
)
